import { EvaluationResponse } from '@module/evaluation/model/EvaluationResponse';
import { evaluationApi } from '../api';
import { BulkSplitExpenseEvaluationsAction } from '@state/types/BulkSplitExpenseEvaluationsAction';

export const bulkOperationsApi = evaluationApi.injectEndpoints({
  endpoints: (build) => ({
    bulkApproveEvaluationExpenses: build.mutation<
      EvaluationResponse,
      {
        id: string;
        expenseIds: number[];
        accountingCodeId: string | null;
        comments: string | null;
      }
    >({
      query: (data) => ({
        url: `/bulk-approve-expenses`,
        method: 'POST',
        data
      }),
      invalidatesTags: (res, _err, { id }) =>
        res ? [{ type: 'EVALUATION', id }] : ['EVALUATION']
    }),

    bulkSplitEvaluationExpenses: build.mutation<
      EvaluationResponse,
      BulkSplitExpenseEvaluationsAction
    >({
      query: (data) => ({
        url: `/bulk-split-expenses`,
        method: 'POST',
        data
      }),
      invalidatesTags: (res, _err, { id }) =>
        res ? [{ type: 'EVALUATION', id }] : ['EVALUATION']
    }),

    bulkApproveSplitEvaluationExpenses: build.mutation<
      EvaluationResponse,
      { evaluationId: string | number }
    >({
      query: ({ evaluationId }) => ({
        url: `/${evaluationId}/bulk-approve-pending-split-expenses`,
        method: 'POST'
      }),
      invalidatesTags: (res, _err, { evaluationId }) =>
        res ? [{ type: 'EVALUATION', evaluationId }] : ['EVALUATION']
    })
  }),
  overrideExisting: false
});

export const {
  useBulkApproveEvaluationExpensesMutation,
  useBulkSplitEvaluationExpensesMutation,
  useBulkApproveSplitEvaluationExpensesMutation
} = bulkOperationsApi;
